module.exports = __webpack_public_path__ + "img/evening.be5030ca.webp";